"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initBraintreeGoogle = void 0;
const src_1 = require("../..");
function initBraintreeGoogle(payment) {
    return __awaiter(this, void 0, void 0, function* () {
        const { clientJsURL, googleJsUrl, braintreeGoogleJsURL, dataCollectorJsURL } = (0, src_1.getBraintreeJsUrls)();
        (0, src_1.setBraintreeGoogleCredentials)(payment);
        yield (0, src_1.loadJS)(clientJsURL, src_1.braintreeOnLoadClient);
        yield (0, src_1.loadJS)(braintreeGoogleJsURL, src_1.braintreeOnLoadClient // Triggering onLoad Client again since window.braintree could have been reassigned by the new script
        );
        yield (0, src_1.loadJS)(googleJsUrl, src_1.braintreeOnLoadGoogle);
        yield (0, src_1.loadJS)(dataCollectorJsURL);
    });
}
exports.initBraintreeGoogle = initBraintreeGoogle;
